/*  ========================================================================
    # Main JavaScript
    ========================================================================  */

import PageStatus from './scripts/page-status';
import MobileMenu from './scripts/mobile-menu';
import OverlayHandling from './scripts/overlay-handling';
import SocialProof from './scripts/social-proof';
import ContactPersonsSlider from './scripts/contact-persons-slider';
import TeaserSlider from './scripts/teaser-slider';

const scripts = [PageStatus, MobileMenu, OverlayHandling, SocialProof, ContactPersonsSlider, TeaserSlider];

document.addEventListener('DOMContentLoaded', () => {
  if (scripts.length > 0 && scripts !== undefined) {
    scripts.forEach(script => {
      script.init();
    });
  }
});
